import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { readPendingInvite } from '@common/utils/startParam';

export type InviteIntro = {
  token: string;
  matchmakerName: string | null;
  note: string | null;
};

export type InviteIntroStore = {
  intro: InviteIntro | null;
  rememberIntro: (intro: InviteIntro) => void;
};

export const INVITE_INTRO_STORAGE_KEY = 'mm_invite_intro';

/**
 * What `invites/open` told about an invite, for the landing's strip. Kept on
 * the device: the friend often registers and comes back through the link in
 * a later launch, which goes straight to the landing without `invites/open`.
 * A load drops an intro whose invite is no longer pending (finished,
 * expired or replaced), so the name and note do not outlive it.
 */
export const useInviteIntroStore = create<InviteIntroStore>()(
  persist(
    (set) => ({
      intro: null,
      rememberIntro: (intro) => set({ intro }),
    }),
    {
      name: INVITE_INTRO_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: ({ intro }) => ({ intro }),
      merge: (persisted, current) => {
        const intro = (persisted as Partial<InviteIntroStore> | undefined)
          ?.intro;
        const pending = readPendingInvite();

        return {
          ...current,
          intro:
            intro && pending && intro.token === pending.token ? intro : null,
        };
      },
    },
  ),
);
